import { PaperHintInterface } from "../talentMarket/testPaper/TestPaperHintConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class PaperHintDialog extends cc.Component {

    @property({type:cc.Node,displayName:"center节点"})
    centerNode:cc.Node = null;

    @property({type:cc.Label,displayName:"提示文本"})
    lb_hint:cc.Label = null;

    data:PaperHintInterface = null;

    onLoad(){
        // this.centerNode.scale = 0;
        // cc.tween(this.centerNode).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }
    
    setData(data:PaperHintInterface){
        this.data = data;
        this.updateDialog();
    }

    updateDialog(){
        this.lb_hint.string = this.data.hintStr;
    }

    onBtnClose(){
        // cc.tween(this.centerNode).to(.5,{scale:0},{easing:cc.easing.backIn}).start();
        // this.scheduleOnce(()=>{
            this.node.destroy();
            this.node.removeFromParent();
        // },.5);
    }

}
